import navbarLogo from '../assets/images/worldlexnetL.png';
import logoWhite from '../assets/images/wlLg1.png';
import defaultUser from '../assets/images/noUser.png';
import moduleGcl from '../assets/images/module/gcl.png';
import  wllg  from '@/assets/images/wllg.jpg';
import waibox from '@/assets/images/waibox.png';

export default {
  navbarLogo,
  logoWhite,
  defaultUser,
  moduleGcl,
  wllg,
  waibox,
  extensionIcons: {
    xls: 'xls',
    xlsx: 'xls',
    pdf: 'pdf',
    png: 'img',
    jpg: 'img',
    jpeg: 'img',
    gif: 'img',
    doc: 'doc',
    docx: 'doc',
    rar: 'rar',
    zip: 'rar',
    txt: 'txt',
  },
};
